module.exports = __webpack_public_path__ + "static/media/lights.0f6121d1.jpg";